<template>
  <div class="wrap cooperate-type">
    <el-row>
      <el-col :md="8" :sm="8" :xs="8" v-for="(typeItem,index) in typeData" :key="index">
        <span class="type-list"  @click="togoLocal('type'+(index+1))">
          <div class="type-left">
            <p class="type-title">{{typeItem.name}}</p>
            <p class="type-detail">{{typeItem.detail}}</p>
          </div>
          <div class="type-right">
            <img :src="require('@/assets/images/icon/'+typeItem.iconSrc)" alt="">
          </div>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script >
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
  setup() {
    const typeData = reactive([
      {
        name: "代理商合作",
        detail: "线下区域代理合作",
        iconSrc: "ic_agent.png"
      },
      {
        name: "市场合作",
        detail: "校园合作、商务合作",
        iconSrc: "ic_market.png"
      },
      {
        name: "校企合作",
        detail: "校企合作、合作办学",
        iconSrc: "ic_schcool.png"
      }
    ]);
    const togoLocal=(domId)=>{
        // document.getElementById(domId).scrollIntoView(true)
        let scrollDis=document.getElementById(domId).offsetTop-72
        window.scroll({'top':scrollDis})
    }
    return {
      typeData,
      togoLocal
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.cooperate-type {
  position: relative;
  background: #fff;
  margin-top: -36px;
  margin-bottom: 40px;
  z-index: 3;
  .type-list {
    display:block;
    padding: 24px 40px;
    overflow: hidden;
  }
  .type-left {
    float: left;
  }
  .type-right {
    float: right;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .type-title {
    font-size: 16px;
    color: #1b1d1f;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .type-detail {
    font-size: 14px;
    color: #869099;
  }
}
</style>
